const EmployeeMappingActionTypes = {
  GET_EMPLOYEEMAPPING_DATA: "GET_EMPLOYEEMAPPING_DATA",
  EMPLOYEEMAPPING_DATA: "EMPLOYEEMAPPING_DATA",

  GET_EMPLOYEEMAPPING_ROLES: "GET_EMPLOYEEMAPPING_ROLES",
  EMPLOYEEMAPPING_ROLES: "EMPLOYEEMAPPING_ROLES",

  GET_EMPLOYEEMAPPING_ACCOUNTS: "GET_EMPLOYEEMAPPING_ACCOUNTS",
  EMPLOYEEMAPPING_ACCOUNTS: "EMPLOYEEMAPPING_ACCOUNTS",

  GET_EMPLOYEEMAPPING_SITES: "GET_EMPLOYEEMAPPING_SITES",
  EMPLOYEEMAPPING_SITES: "EMPLOYEEMAPPING_SITES",

  UPDATE_USERMEMBERSHIP_DATA_START: "UPDATE_USERMEMBERSHIP_DATA_START",
  UPDATE_USERMEMBERSHIP_DATA_SUCCESS: "UPDATE_USERMEMBERSHIP_DATA_SUCCESS",

  UPDATE_USERMEMBERSHIP_DELETE_START: "UPDATE_USERMEMBERSHIP_DELETE_START",
  UPDATE_USERMEMBERSHIP_DELETE_SUCCESS: "UPDATE_USERMEMBERSHIP_DELETE_SUCCESS",




};
export default EmployeeMappingActionTypes;